import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.scss';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { ApolloProvider} from "@apollo/client";
import {Provider} from "react-redux";
import {store} from "./store";
import client from "./graphql/client";

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);


root.render(
  <React.Fragment>
      <ApolloProvider client={client}>
          <Provider store={store}>
            <App />
          </Provider>
      </ApolloProvider>
  </React.Fragment>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
